<template>
  <div v-if="isShowWaterMark" class="watermark">
    {{ env.toUpperCase() }}
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig()
const env = ref('local')
const isShowWaterMark = ref(false)

const getEnv = () => {
  if (config.public.env) {
    env.value = config.public.env
  }
  return env
}

onMounted(() => {
  getEnv()
  isShowWaterMark.value = !['stage', 'prod'].includes(env.value)
})

</script>

<style lang="scss" scoped>
.watermark {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 55px;
  color: $rose-500;
  opacity: 0.1;
  pointer-events: none;
}
</style>
